import React from 'react'
const Graphic_Design = () => {
    return (
        <>
            <section className="web_development">
                <div className="container">
                    <div className="content">
                        <h2>Graphic</h2>
                        <h1>Designing</h1>
                    </div>
                </div>
            </section>
            <section className="web_development1">
                <div className="container py-5">
                    <div className="row d-flex align-items-center">
                        <div className="col-lg-8">
                            <div className="content">
                                <h2>Overview Graphic Design Service</h2>
                                <p style={{ textAlign: "justify" }}>Users are consuming data every nanosecond of their time, however our immaculate design approach not only influences but converts the same users. Creative junkies at the Muhammad Rizwan look to change the magnitude of their storytelling techniques, utilizing not only the many elements of graphic designing but also bringing into play human elements to your brand persona.Users are consuming data every nanosecond of their time, however our immaculate design approach not only influences but converts the same users. Creative junkies at the Muhammad Rizwan look to change the magnitude of their storytelling techniques, utilizing not only the many elements of graphic designing but also bringing into play human elements to your brand persona.</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <img src="img/graphic.jpeg" className='img-fluid' alt="Website" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="web_development2">
                <div className="container">
                    <div className="content">
                        <h6>SERVICES</h6>
                        <h1>WE OFFER<span style={{ color: "#30ADA7", fontFamily: "heading" }}>GRAPHIC DESIGN</span> SERVICES</h1>
                        <p>We think big and have hands in all leading technology platforms to provide you wide array of services.</p>
                    </div>
                </div>
            </section>
            <section className="web_development3">
                <div className="container">
                    <div className="row py-5">
                        <div className="col-lg-4 col-md-6 my-2 d-flex align-items-stretch">
                            <div className="card p-3 text-center">
                                <center><img src="img/branding.png" width={50} alt="branding" /></center>
                                <h4 className='text-white py-1'>Logo Designing</h4>
                                <p style={{ textAlign: "justify" }}>Muhammad Rizwan is digitally forward and creative that embrace challenges with our professional designers, thus improving and facilitating a better communications cycle.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 my-2 d-flex align-items-stretch">
                            <div className="card p-3 text-center">
                                <center><img src="img/thinking.png" width={50} alt="thinking" /></center>
                                <h4 className='text-white py-1'>Packaging Design</h4>
                                <p style={{ textAlign: "justify" }}>To provide a standard way of living, we at Muhammad Rizwan plan advanced packaging designs that enable individuals to discover all the options and increase their sales with additional revenues.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 my-2 d-flex align-items-stretch">
                            <div className="card p-3 text-center">
                                <center><img src="img/collateral.png" width={50} alt="collateral" /></center>
                                <h4 className='text-white py-1'>Marketing Collaterals</h4>
                                <p style={{ textAlign: "justify" }}>By taking benefits of real user data and analytics, Muhammad Rizwan understands the number of promotional activities or marketing techniques that you did for your small business.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 my-2 d-flex align-items-stretch">
                            <div className="card p-3 text-center">
                                <center><img src="img/corporative.png" width={50} alt="corporative" /></center>
                                <h4 className='text-white py-1'>Corporate Design</h4>
                                <p style={{ textAlign: "justify" }}>With corporate branding on a whole new level, reduce your operational costs and have strong communication patterns worldwide without any hassle.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 my-2 d-flex align-items-stretch">
                            <div className="card p-3 text-center">
                                <center><img src="img/graphic-design.png" width={50} alt="graphic" /></center>
                                <h4 className='text-white py-1'>Custom Graphic Designs</h4>
                                <p style={{ textAlign: "justify" }}>With our custom graphic designing and print designing services, Muhammad Rizwan serves in refining customer interactions and business models.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 my-2 d-flex align-items-stretch">
                            <div className="card p-3 text-center">
                                <center><img src="img/newsletter.png" width={50} alt="news" /></center>
                                <h4 className='text-white py-1'>Newsletter Designing</h4>
                                <p style={{ textAlign: "justify" }}>Let Muhammad Rizwan support you to have better relationships with your clients by making use of interactive newsletter designs.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Graphic_Design